export enum GroupStatus {
  CROWDED = 'CROWDED',
  IDEAL = 'IDEAL',
  NORMAL = 'NORMAL',
  PERSONNEL_SHORTAGE = 'PERSONNEL_SHORTAGE',
  CRITICAL_PERSONNEL_SHORTAGE = 'CRITICAL_PERSONNEL_SHORTAGE',
}
